import { type ChatOptions } from '@chatbot/typings/types';

export const defaultMountingTarget = '#chat-container';

// LocalStorage and API keys
export const CHAT_SESSION_KEY = 'sessionId';
export const CHAT_INPUT_KEY = 'chatInput';
export const CONVERSATION_ID_KEY = 'chat_conversation_id';

// API Actions
export const API_ACTION_LOAD_SESSION = 'loadPreviousSession';
export const API_ACTION_SEND_MESSAGE = 'sendMessage';

export const defaultOptions: Required<ChatOptions> = {
    // Core configuration
    target: defaultMountingTarget,
    venueId: '',
    n8nWebhookChatUrl: '',
    venueSettingsUrl: '',
    agent: 'STARLIGHT',
    environment: 'development',

    // Webhook configuration
    metadata: {},

    // UI Configuration
    title: 'AI Chat Assistant',
    avatarUrl: '',
    presenceStatus: 'Online',
    welcomeMessage: '',

    // Theme and styling
    theme: {
        primaryColor: '#00453a',
        backgroundColor: '#ffffff',
        textColor: '#333333',
        borderColor: '#e0e0e0',
        borderRadius: '8px',
    },
    maxWidth: '400px',
    mode: 'fixed',
    position: {
        xPosition: '20px',
        yPosition: '20px',
    },
    showFullscreenButton: false,
    showFloatingButtonTooltip: true,
    floatingButtonTooltip: 'Chat with us',

    // Initial state
    initialMessages: [],
};
